export default __webpack_public_path__ + "static/media/waveapp-logotype.b97f4129.svg";